<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="ENDO Metal-Sleeve"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    ENDO Metal-Sleeve
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/endo/endo-top-img.png"
            className="h-lg-540px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    Endo's Metal Sleeve business uses metal plasticity processing technology that we've developed on our own.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    The high level of technology developed contributes to the enhancement of the products which requires precise quality.
                </p>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Manufacturing capability enabling mass production with high quality has been established.
                </p>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    That quality and technology has attracted attention from a variety of industries and has the great possibilities.
                </p>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Endo's Metal Sleeve business started from the progress of our metal plasticity processing technology.
                </p>
                <p class="page-text color-grey-51">
                    The metal sleeve that we've developed through long term research makes possible seamless metal processing to  a micro-thinness of approximately 10μ and is essential as functional parts for high-performance OA equipment  for which we are now gaining a large market share.
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Advantages">
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon1.png"
                        iconWidth="50"
                        num="01">
                        Maximize the advancement of products that require precise quality with high technology
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon2.png"
                        iconWidth="50"
                        num="02">
                        A production system that enables mass production while maintaining high quality
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon3.png"
                        iconWidth="50"
                        num="03">
                        Technology and quality are attracting attention in various industries and have great potential
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon4.png"
                        iconWidth="50"
                        num="04">
                        Ultra-Thin Seamless metal processing is possible, and functional parts essential for high-performance OA equipment
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <div class="sub-section">
            <v-container>

                <sub-line-layout
                tit="ENDO Metal-Sleeve"
                className="full">
                    <v-row class="my-n10 my-lg-n40">
                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-1.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Ultra-Thin Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    By being able to do ultra-thin processing to a wall thickness of less than 40μm, we have made it possible to bend a sleeve like a resin film. Excellent heat resistance, corrosion resistance, wear resistance, and rigidity.
                                </p>

                                <standard
                                diameter="From φ18mm toφ45mm"
                                weight="From 27μm to 100μm"
                                length="Up to 420mm">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-2.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Thin Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    Achieves processing of wall thickness of less than 100μm that would be very hard to achieve with other production methods. Can be used as thin seamless pipe featuring high temperature strength and corrosion resistance.
                                </p>

                                <standard
                                diameter="From φ10mm to φ30mm"
                                weight="From 100μm to 300μm"
                                length="Up to 420mm">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-3.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Ultra-Thin Seamless Belt
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    Excellent heat resistance and corrosion resitance. Additionally, by applying a formula to improve fatigue, it exhibits excellent characterisitics as a base material for drive transmission belt.
                                </p>

                                <standard
                                diameter="From φ20mm toφ160mm"
                                weight="From 15μm to 60μm"
                                length="From 3mm to 400mm">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-4.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Small Diameter, <br class="d-none d-xl-block">
                                    Ultra-Thin Seamless Ring
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    Seamless ring for small diameter, thin applications. Minimum thickness of t15μm and under consideration for medical equipment parts.
                                </p>

                                <standard
                                diameter="From φ3mm toφ30mm"
                                weight="From 15μm to 60μm"
                                length="From 3mm">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-5.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Small Diamete, Ultra-Thin <br class="d-none d-xl-block">
                                    Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    Seamless pipe for small diameter, thin applications. Minimum thickness of t15μm and under consideration for electrical equipment, medical equipment and automobile parts.
                                </p>

                                <standard
                                diameter="From φ3mm toφ10mm"
                                weight="From 15μm to 100μm"
                                length="Up to 400mm">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-6.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Seamless Case <br class="d-none d-xl-block">
                                    with Bottom
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail min-h-xl-120px">
                                    Excellent corrosion resistance since there is no welded area on the bottom or cylindrical part. Exhibits excellent characteristics, even in harsh usage environments. Has a recrord of being under consideration as a case for batteries.
                                </p>

                                <standard
                                diameter="From φ20mm toφ60mm"
                                weight="From 50μm to 300μm"
                                length="From 50mm to 400mm">
                                </standard>

                            </image-detail>

                        </v-col>
                    </v-row>
                </sub-line-layout>

            </v-container>
        </div>

        <div class="sub-section sub-section--last">
            <v-container>

                <inquiry
                src="/images/sub/distributor/endo/endo-img1.png"
                name="J.H HWANG"
                tel="+82-31-765-2268"
                mail="hwangjoe@ist-co.kr"
                fax="+82-31-765-2389"
                link="http://endo-mfg.co.jp/eng/"
                linkBg="/images/sub/distributor/endo/endo-img2.png">
                </inquiry>

            </v-container>
        </div>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/en/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
import ImageDetail from "@/components/client/en/sub/sub-image-detail.vue";
import Standard from "@/components/client/en/sub/sub-standard.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
        ImageDetail,
        Standard,
    },
};
</script>

<style lang="scss" scoped>
</style>